export const requiredFields = ['UUID', 'name'];

export const defaultFieldError = {
  UUID: false,
  name: false,
};
